import('@sitepark/component-input-geolocation').then(({ register }) => register());
